import Typography from '../../Typography';

type DataTableTotalProps = {
  isLoading: boolean;
  totalRows: number | undefined;
};

const DataTableTotal = ({ isLoading, totalRows }: DataTableTotalProps) => {
  if (isLoading) return null;
  const numberFormatter = Intl.NumberFormat('pt-BR');

  return (
    <Typography color='secondary' variant='button-label'>
      Total:{' '}
      <span className='font-normal'>
        {totalRows && numberFormatter.format(totalRows)}
      </span>
    </Typography>
  );
};

export default DataTableTotal;
